// IMAGES
import gradientLine from "assets/img/decorationLine.png";
// STYLES
import "./decorationLine.scss";

const DecorationLine = () => {
	return <img src={gradientLine} alt="decorationLine" className="decorationLine" />;
};

export default DecorationLine;
